import { Link } from "react-router-dom";
import Icons from "./sub/Icons";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import Section from "../Section";

const Header = ({ location }) => {

  const background = location === "landing-page" ? 'white' : '#1A273D';
  const color = location === "landing-page" ? '#1A273D' : 'white';
  const logo = location === "landing-page" ? Icons.TurgoilLogo : Icons.TurgoilLogoWhite;
  const variant = location === "landing-page" ? 'light' : 'dark';

  return (
    <div className="landing-header">
      <Navbar style={{ background: background }} variant={variant} expand="lg" className="py-4">
        <Section backgroundColor={background}>
          <div className="navContainer">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

              <Navbar.Brand as={Link} to="/">
                {logo}
              </Navbar.Brand>

              <Navbar.Toggle style={{ height: '55px' }} aria-controls="basic-navbar-nav" />
            </div>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto gap-2 gap-lg-5" >

                <Nav.Link as={Link} to="/solutions" style={{ display: 'flex' }}>
                  <div className="header-btn" style={{ color: color }}>
                    Lahendused
                  </div>
                </Nav.Link>

                <Nav.Link as={Link} to="/article/et-EE" style={{ display: 'flex' }}>
                  <div className="header-btn" style={{ color: color }}>
                    Kliendilood
                  </div>
                </Nav.Link>

                <Nav.Link as={Link} to="/contact" style={{ display: 'flex' }}>
                  <div className="header-btn" style={{ color: color }}>
                    Kontakt
                  </div>
                </Nav.Link>

                <Nav.Link as={Link} to="/signin">
                  <div className="header-btn" style={{ color: color }}>
                    <i className="bi bi-person icon-mobile" style={{ fontSize: '18px' }}></i>
                    <span>Logi sisse</span>
                  </div>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Section>
      </Navbar>
    </div>
  )
};

export default Header;
